import { defineMessages } from 'react-intl';

export default defineMessages({
    rvDriverTitle: {
        id: 'quoteandbind.rv.views.rv-driver-details.Driver',
        defaultMessage: 'Driver',
    },
    rvDriverTitleNumber: {
        id: 'quoteandbind.rv.views.rv-driver-details.Driver:',
        defaultMessage: 'Driver:',
    },
    rvDriver: {
        id: 'quoteandbind.views.quote.rv.Personal Auto Driver',
        defaultMessage: 'Personal Auto Driver',
    },
    removeDriverTitle: {
        id: 'quoteandbind.rv.controllers.BADriverDetailsCtrl.Remove Driver?',
        defaultMessage: 'Remove Driver?',
    },
    removeDriverDescription: {
        id: 'quoteandbind.rv.drivers.remove-driver.message',
        defaultMessage: 'Are you sure you want to remove this driver from the list of drivers?',
    },
    rvAddAnotherDriverTitle: {
        id: 'quoteandbind.rv.views.rv-driver-details.Add Another Driver?',
        defaultMessage: 'Add Another Driver?',
    },
    rvAddDriverButtonText: {
        id: 'quoteandbind.rv.views.rv-driver-details.Add Driver',
        defaultMessage: 'Add Driver',
    },
    rvAdd: {
        id: 'quoteandbind.rv.views.rv-driver-details.Add',
        defaultMessage: 'Add',
    }
});
